import React, { useState, useEffect, useRef } from 'react';
import './VideoShowcase.css';

const VideoShowcase = () => {
  const [videos, setVideos] = useState({});
  const videoRefs = useRef([]);
  const sectionRef = useRef(null);
  const inViewRef = useRef(false);

  useEffect(() => {
    fetch('/api/admin/showcase-videos')
      .then(r => r.json())
      .then(data => setVideos(data))
      .catch(() => {});
  }, []);

  // Play/pause videos based on viewport visibility
  useEffect(() => {
    if (!sectionRef.current) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        inViewRef.current = entry.isIntersecting;
        if (entry.isIntersecting) {
          videoRefs.current.forEach(v => { if (v && v.src) v.play().catch(() => {}); });
        } else {
          videoRefs.current.forEach(v => { if (v) v.pause(); });
        }
      },
      { rootMargin: '200px 0px', threshold: 0.1 }
    );
    observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, [videos]);

  const slots = ['clip-1', 'clip-2', 'clip-3'];
  const uploadedCount = slots.filter(s => videos[s]).length;
  if (uploadedCount === 0) return null;

  const togglePlay = (idx) => {
    const v = videoRefs.current[idx];
    if (!v) return;
    if (v.paused) v.play();
    else v.pause();
  };

  return (
    <div className="vs-section" ref={sectionRef}>
      <div className="vs-header">
        <div className="vs-badge">
          <span className="vs-dot"></span>
          Real Output
        </div>
        <h3 className="vs-title">
          Watch <span className="vs-gradient">actual clips</span> made with VlogClip AI
        </h3>
        <p className="vs-subtitle">
          One YouTube video pasted, three viral-ready clips returned. Each clip is auto-cropped to the speaker,
          captioned with AI-timed text, and ready to post on TikTok, Reels, or Shorts — no editing needed.
        </p>
      </div>

      <div className="vs-phones">
        {slots.map((slot, i) => {
          const url = videos[slot];
          if (!url) return null;
          const poster = '/images/showcase/' + slot + '.jpg';
          return (
            <div className="vs-phone" key={slot} onClick={() => togglePlay(i)}>
              <div className="vs-phone-notch"></div>
              <div className="vs-phone-screen">
                <video
                  ref={el => videoRefs.current[i] = el}
                  src={url}
                  poster={poster}
                  loop
                  muted
                  playsInline
                  preload="none"
                  onCanPlay={e => { if (inViewRef.current) e.target.play().catch(() => {}); }}
                />
                <div className="vs-overlay">
                  <div className="vs-overlay-tag">
                    <span className="vs-tag-dot"></span>
                    LIVE
                  </div>
                </div>
              </div>
              <div className="vs-phone-caption">Real clip #{i + 1}</div>
            </div>
          );
        })}
      </div>

      <div className="vs-footer">
        <span>👆 Tap any phone to pause • Sound is off by default</span>
      </div>
    </div>
  );
};

export default VideoShowcase;
